import { MutationTree } from 'vuex';
import { iReview } from '@/entities/review/review.types';
import Profile from '@/entities/profile/profile';
import { iProfile } from '@/entities/profile/profile.types';
import { ProfileState } from '../../types/profile-module.types';

export enum PROFILE_MUTATIONS {
  SET_REVIEWS = 'SET_REVIEWS',
  APPEND_REVIEWS = 'APPEND_REVIEWS',
  SET_PROFILE = 'SET_PROFILE',
  UPDATE_PROFILE_ATTRIBUTES = 'UPDATE_PROFILE_ATTRIBUTES',
}

export const mutations: MutationTree<ProfileState> = {
  [PROFILE_MUTATIONS.SET_REVIEWS](state, value: iReview[]) {
    state.reviews = value;
  },
  [PROFILE_MUTATIONS.APPEND_REVIEWS](state, value: iReview[]) {
    state.reviews.push(...value);
  },
  [PROFILE_MUTATIONS.SET_PROFILE](state, value: iProfile) {
    state.profile = value;
  },
  [PROFILE_MUTATIONS.UPDATE_PROFILE_ATTRIBUTES](state, value: Partial<iProfile>) {
    if (!state.profile) return;

    const newProfile = new Profile(
      state.profile.id,
      value.gamertag || state.profile.gamertag,
      value.profileCover || state.profile.profilePic,
      value.profilePic || state.profile.profileCover,
      value.slug || state.profile.slug,
    );

    state.profile = newProfile;
  },
};
